<template>
  <div class="hris-page hris-messaging-page">
    <div class="hris-page-inner">
      <main class="hris-card chat-main">
        <header class="chat-header">
          <h2 class="hris-panel-title">Chat</h2>

          <!-- User selectors -->
          <div class="chat-selectors">
            <label for="sender-id">Sender ID</label>
            <input id="sender-id" class="chat-selector-input" v-model="senderId" placeholder="Sender ID" />
            <label for="receiver-id">Receiver ID</label>
            <input id="receiver-id" class="chat-selector-input" v-model="receiverId" placeholder="Receiver ID" />
            <input class="chat-selector-input" v-model="groupId" placeholder="Group ID (Optional)" />
            <q-btn unelevated class="hris-q-primary" label="Start Chat" @click="startChat"></q-btn>
          </div>
        </header>

        <ul id="messages" class="chat-messages">
          <li
            v-for="msg in messages"
            :key="msg.id"
            :class="['message', msg.sender == senderId ? 'sent' : 'received']"
            :data-id="msg.id"
          >
            <div>{{ msg.content }}</div>

            <img
              v-if="msg.image"
              :src="'https://franciscopantry.com' + msg.image"
              class="chat-message-image"
            />

            <div
              v-if="msg.sender == senderId"
              class="status"
            >
              {{ msg.status || 'sent' }}
            </div>
          </li>
        </ul>

        <div class="input-area">
          <input class="chat-text-input" v-model="content" placeholder="Type a message..." />
          <input type="file" @change="onFile" />
          <q-btn unelevated round class="hris-q-primary chat-send-btn" label="➤" @click="sendMessage"></q-btn>
        </div>
      </main>
    </div>
  </div>
</template>


<script>
import { io } from "socket.io-client";

export default {
  data() {
    return {
      senderId: "",
      receiverId: "",
      groupId: "",
      token: null,
      socket: null,
      messages: [],
      content: "",
      image: null,
      mode: "private" // private | group
    };
  },
  mounted() {
    if (!this.token) return console.error("Token missing");

    this.socket = io("https://115.84.243.189:5000/");

    this.socket.on("receive_message", (msg) => {
      this.messages.push(msg);
      this.scrollToBottom();
      if (!this.groupId) {
        this.socket.emit("delivered_confirm", { message_id: msg.id });
      }
    });

    this.socket.on("message_status", ({ message_id, status }) => {
      const m = this.messages.find(m => m.id === message_id);
      if (m) m.status = status;
    });

    this.socket.on("messages_read", ({ message_ids }) => {
      message_ids.forEach(id => {
        const m = this.messages.find(m => m.id === id);
        if (m) m.status = "read";
      });
    });
  },
  methods: {
    startChat() {
      if(this.groupId){
        this.startGroupChat()
      }else{
        this.startPrivateChat()
      }
    },

    async startPrivateChat() {
      console.log(this.groupId)
      if (!this.senderId || !this.receiverId) return alert("Enter sender & receiver");
      this.mode = "private";
      this.groupId = "";
      this.messages = [];
      this.socket.emit("register", this.senderId);
      await this.loadMessages();
    },

    async startGroupChat() {
      if (!this.senderId || !this.groupId) return alert("Enter sender & group ID");
      this.mode = "group";
      this.receiverId = "";
      this.messages = [];
      this.socket.emit("register", this.senderId);
      this.socket.emit("join_group", { group_id: this.groupId });
      await this.loadGroupMessages();
    },

    scrollToBottom() {
      this.$nextTick(() => {
        document.querySelector("#messages li:last-child")?.scrollIntoView({ behavior: "smooth" });
      });
    },

    async loadMessages() {
      const fd = new FormData();
      fd.append("sender_id", this.senderId);
      fd.append("receiver_id", this.receiverId);

      const res = await fetch("https://franciscopantry.com/chats", {
        method: "POST",
        headers: { Authorization: `Bearer ${this.token}` },
        body: fd
      });
      const data = await res.json();
      this.messages = data.data || [];
      this.scrollToBottom();
    },

    async loadGroupMessages() {
      const fd = new FormData();
      fd.append("user_id", this.senderId);
      fd.append("group_id", this.groupId);

      const res = await fetch("https://franciscopantry.com/group-chats", {
        method: "POST",
        headers: { Authorization: `Bearer ${this.token}` },
        body: fd
      });
      const data = await res.json();
      this.messages = data.data || [];
      this.scrollToBottom();
    },

    onFile(e) {
      this.image = e.target.files[0];
    },

    async sendMessage() {
      if (!this.content && !this.image) return;

      if (this.image) {
        const fd = new FormData();
        fd.append("sender_id", this.senderId);
        if (this.mode === "private") fd.append("receiver_id", this.receiverId);
        if (this.mode === "group") fd.append("group_id", this.groupId);
        if (this.content) fd.append("content", this.content);
        fd.append("image", this.image);

        const url = this.mode === "group"
          ? "https://franciscopantry.com/save-group-chat"
          : "https://franciscopantry.com/save-chat";

        const res = await fetch(url, {
          method: "POST",
          headers: { Authorization: `Bearer ${this.token}` },
          body: fd
        });
        const data = await res.json();
        this.socket.emit("send_message", { ...data.message, token: this.token });
      } else {
        console.log('message mode', this.mode)
        console.log('id', this.groupId)
        console.log('receiver id', this.receiverId)
        this.socket.emit("send_message", {
          sender_id: this.senderId,
          receiver_id: this.mode === "private" ? this.receiverId : null,
          group_id: this.mode === "group" ? this.groupId : null,
          content: this.content,
          token: this.token
        });
      }

      this.content = "";
      this.image = null;
    }
  }
};
</script>

<style scoped>
.hris-messaging-page {
  min-height: 100%;
}

.chat-main {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 140px);
  min-height: 480px;
  padding: 22px 26px;
}

.chat-header {
  padding-bottom: 18px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--hris-border-light);
}

.chat-selectors {
  margin-top: 12px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 0.8125rem;
  color: var(--hris-text-secondary);
}

.chat-selector-input {
  padding: 8px 12px;
  border: 1px solid var(--hris-border);
  border-radius: var(--hris-radius-sm);
  font-family: var(--hris-font);
  font-size: 0.875rem;
  color: var(--hris-text);
  outline: none;
  transition: border-color 0.2s;
}

.chat-selector-input:focus {
  border-color: var(--hris-accent);
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  list-style: none;
  margin: 0;
  padding: 8px 4px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chat-messages .message {
  max-width: 65%;
  padding: 10px 14px;
  border-radius: var(--hris-radius-sm);
  font-size: 0.875rem;
  line-height: 1.5;
  word-break: break-word;
}

.chat-messages .sent {
  align-self: flex-end;
  background: var(--hris-accent);
  color: #fff;
  border-bottom-right-radius: 4px;
}

.chat-messages .received {
  align-self: flex-start;
  background: var(--hris-surface-muted);
  color: var(--hris-text);
  border-bottom-left-radius: 4px;
}

.chat-message-image {
  max-width: 200px;
  display: block;
  margin-top: 6px;
  border-radius: var(--hris-radius-sm);
}

.chat-messages .status {
  font-size: 0.6875rem;
  margin-top: 4px;
  opacity: 0.75;
}

.input-area {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 16px;
  margin-top: 8px;
  border-top: 1px solid var(--hris-border-light);
}

.chat-text-input {
  flex: 1;
  padding: 10px 14px;
  border: 1px solid var(--hris-border);
  border-radius: var(--hris-radius-sm);
  font-family: var(--hris-font);
  font-size: 0.9375rem;
  color: var(--hris-text);
  outline: none;
  transition: border-color 0.2s;
}

.chat-text-input:focus {
  border-color: var(--hris-accent);
}

.chat-send-btn {
  flex-shrink: 0;
}
</style>

